module.exports = __webpack_public_path__ + "img/mtag.8a3b39c.png";